<template>
	<span>
		<button v-if="fullPasswordValue" @click="clickLink" class="linkButton passwordLink">{{passwordValue}}</button>
		<span v-else class="passwordLink">{{passwordValue}}</span>
	</span>	
</template>
<script>
	export default {
		name: 'PasswordLink',
		props: ['password', 'fullPassword'],
		data() {
			return {
				passwordValue: this.password,
				fullPasswordValue: this.fullPassword
			}
		},
		methods: {
			clickLink() {
				this.passwordValue = this.fullPasswordValue;
				this.fullPasswordValue = null;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/PasswordLink.vue